<template>
  <div>
    <div class = "rightimg">
      <b-img center src="./assets/ip.jpg" rounded="top" width="400" height="400" 
      fluid alt="Responsive image"  />
      <i>Рис. 1. Пример организации IP-телефонии</i>
    </div>
 <h2>Об IP-телефонии</h2>
 <p>IP-телефония (читается <ай-пи>);  современный высокотехнологичный способ связи, 
 возникший на стыке традиционных услуг связи и сети Интернет. 
 Конкретно, под IP-телефонией понимается технология, позволяющая использовать сеть Интернет или 
 любую другую IP-сеть в качестве средства организации и ведения международных и междугородных 
 телефонных разговоров в режиме реального времени.</p>

 
<!-- <img src="./assets/ip.jpg"> -->
<!-- <b-img-lazy src="./assets/ip.jpg" center fluid-grow width="600" height="400" blank-color="#bbb" alt="img" class="my-5" /> -->
<h3>Как работает IP-телефония ?</h3>
<br>
<p>Рассмотрим конкретный пример. Вам надо позвонить из офиса в Таганроге на Московский номер телефона 
  123-45-67 с помощью IP-телефонии. Вы поднимаете трубку телефона подключенного к IP шлюзу. 
  Это оборудование называется <шлюзом> потому, что оно соединяет две разнородные сети: 
  телефонную сеть и сеть Интернет. <Шлюз> всегда соединяет что-то разное, непосредственно не стыкующееся.</p>
  К примеру, шлюзы, которые продаёт своим клиентам компания "Мегалинк", выглядят так:
    <br>
    <br>
    <b-container fluid class="p-4 bg-dark">
    <b-row>
      <b-col>
        <b-img thumbnail fluid src="./assets/ht502.jpg" alt="Thumbnail" />
          <i class = "lightfont"> Двухпортовый шлюз Grandstream HT502</i>
      </b-col>
      <b-col>
        <b-img thumbnail fluid src="./assets/ht812.jpg" alt="Thumbnail" />
        <i class = "lightfont"> Двухпортовый шлюз Grandstream HT812</i>
      </b-col>
      <b-col>
        <b-img thumbnail fluid src="./assets/tau2m.jpg" alt="Thumbnail" />
        <i class = "lightfont">  Двухпортовый шлюз Eltex ТАУ2-ip</i>
      </b-col>
    </b-row>
  </b-container>
  <br>
  <br>
Итак, вы поднимаете трубку, слышите гудок и набраете номер 123-45-67.Схематично это будет выглядеть так:
<br>
<br>
<b-img center src="./assets/diagram.png" rounded="top"  fluid alt="Responsive image"  />
<br>
<br>
Т.е. организация, желающая использовать IP-телефонию по выделенной линии, должна иметь 
выделенный канал к сети Интернет и установить у себя в офисе шлюз IP-телефонии.

<br>
<br>
<br>
<h3>Почему IP-телефония <дешевле>? </h3>

Проще сказать, почему дороже традиционная междугородняя связь:

государство активно участвует в ценообразовании на услуги междугородной и международной связи 
(как и на другие особые группы товаров через акцизы и пошлины: алкоголь, табак, нефтепродукты, автомобили и т.п.). 
Участие реализуется посредством законов, 
обязывающих операторов традиционной телефонной связи покупать <межгород> только у Ростелекома;
операторов традиционной связи обязывают заниматься перекрёстным субсидированием услуг местной телефонной связи 
(особенно сельской) за счёт доходов от междугородней и международной телефонной связи;
технологии связи (в т.ч. оборудование и каналы), используемые в традиционной связи были разработаны и 
запущены в эксплуатацию десятки лет назад. В сегодняшнем дне они технологически устарели, 
что приводит к высоким эксплуатационным затратам;
операторы традиционной связи, в большинстве своём созданные на базе предприятий местной 
электросвязи, вынуждены закладывать в цену своих услуг большую наценку для покрытия высоких издержек,
 связанных с неэффективностью их функционирования.
<br>
<br>
<h3>Какое качество связи обеспечивает IP-телефония?</h3>

Если оператор IP-телефонии всё сделал <правильно>, он реально может достичь качества услуг, соизмеримого с 
качеством услуг сотовой связи. Несмотря на то, что качество обычной телефонной связи выше, сотовой связью пользуются из-за её мобильности, а IP-телефонией – из-за её цены.

<p>Сравнение с другими технологиями</p>

Нельзя сказать однозначно, какая технология <лучше> или <хуже>, можно лишь сравнить <плюсы> и <минусы> одной технологии перед другой.
  <br>
  <b>Преимущества доступа по выделенной линии:</b>
  <b-list-group>
    <b-list-group-item variant="success">Услуга ощутимо дешевле в сравнении с использованием традиционной телефонии.</b-list-group-item>
    <b-list-group-item variant="success">Единый номерной план телефонов в случае удалённых офисов
  (cотрудники могут набирать внутренние номера телефонов сослуживцев даже незадумываясь о том, что коллеги находяться в других городах).</b-list-group-item>
    <b-list-group-item variant="success">Соединение устанавливается быстрее.</b-list-group-item>
    <b-list-group-item variant="success">На возможность получения услуги никак не влияет загруженность телефона оператора IP-телефонии.</b-list-group-item>
  </b-list-group>

  <b>Недостатки доступа по выделенной линии:</b>

  <b-list-group>
    <b-list-group-item variant="warning">Относительно большие начальные затраты на шлюз IP-телефонии и, возможно, на организацию выделенного канала к сети Интернет.</b-list-group-item>
  </b-list-group>
  <br>
  <br>
  <h3>К кому конкретно обращаться?</h3>

  За дополнительной информацией обращайтесь: 

  <b-list-group>
    <b-list-group-item variant="dark">к нам в офис: г. Таганрог ул. Чехова 318</b-list-group-item>
    <b-list-group-item variant="dark">По телефонам: <b>8(8634)431-431</b> или <b>89281155130</b></b-list-group-item>
    <b-list-group-item variant="dark">Задать вопросы можно по электронной почте: <b>voip@tagan.ru</b></b-list-group-item>
  </b-list-group>
  <br>
  <br>
  </div>
</template>
<script>

export default {
  
}
</script>
<style scoped>
#about_text {
  width: 90%;
  margin: auto;
}
p {
  text-align: left
}

.rightimg  {
    float: right; /* Выравнивание по правому краю  */ 
    margin: 7px 0 7px 7px; /* Отступы вокруг картинки */
   }
.lightfont {
  color:aliceblue
}
</style>
>


// WEBPACK FOOTER //
// src/About.vue